class AppContent extends HTMLElement {
   connectedCallback() {
      const body = this.innerHTML; // the page's content
      this.innerHTML = `<main class="main">${body}</main>`;
   }
}
customElements.define("app-content", AppContent);
